import { Box, Link, Stack, Typography } from '@montugroup/design-system';
import ChevronRight from '@mui/icons-material/ChevronRight';
import HelpCenterOutlined from '@mui/icons-material/HelpCenterOutlined';
import MailOutline from '@mui/icons-material/MailOutline';
import Send from '@mui/icons-material/Send';
import { styled } from '@mui/material';

import BackButton from '@/components/common/backButton/BackButton';

const LinkCard = styled(Link)(({ theme }) => ({
  border: '1px solid rgba(0, 0, 0, 0.2)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: theme.spacing(4),
  borderRadius: '0.5rem',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: theme.palette.action.hover,
    transition: 'background-color 0.3s ease',
  },
}));

const IconContainer = styled(Box)(({ theme }) => ({
  border: '1px solid rgba(0, 0, 0, 0.2)',
  backgroundColor: '#FFFCF2', // TODO: Change to theme warm white once design system is updated
  marginRight: theme.spacing(4),
  padding: theme.spacing(2.5),
  borderRadius: '0.5rem',
}));

const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  lineHeight: theme.spacing(6),
}));

export default function PatientHelp() {
  const supportLinks = [
    {
      href: 'https://support.umeds.com.au/hc/en-au/',
      text: 'Help and support centre',
      icon: HelpCenterOutlined,
      target: '_blank',
    },
    {
      href: 'https://support.umeds.com.au/hc/en-au/requests/new ',
      text: 'Submit a request',
      icon: Send,
      target: '_blank',
    },
  ];
  const contactLinks = [
    {
      href: 'mailto:info@umeds.com.au',
      text: 'Email',
      icon: MailOutline,
      subText: 'info@umeds.com.au',
    },
  ];

  return (
    <>
      <Box display="flex" pb={{ xs: 4, sm: 2 }}>
        <BackButton />
        <Typography
          variant="h5"
          component="h1"
          sx={(theme) => ({ color: theme.palette.primary.main })}
          lineHeight={(theme) => theme.spacing(9)}
        >
          We&apos;re here to help
        </Typography>
      </Box>
      <Typography
        sx={(theme) => ({ color: theme.palette.primary.main })}
        pb={6}
        lineHeight={(theme) => theme.spacing(6)}
      >
        Our customer service team is available Monday to Friday from 8AM to 9PM (AEST).
      </Typography>
      <Stack gap={4} mb={10}>
        {supportLinks.map((link) => (
          <LinkCard key={link.href} href={link.href} target={link.target} maxWidth={{ sm: '420px' }}>
            <Stack direction="row" alignItems="center">
              <IconContainer>
                <link.icon sx={{ color: 'primary.main' }} />
              </IconContainer>
              <Text>{link.text}</Text>
            </Stack>
            <ChevronRight sx={{ color: 'primary.main' }} />
          </LinkCard>
        ))}
      </Stack>

      <Typography
        variant="subtitle1"
        component="h2"
        sx={(theme) => ({ color: theme.palette.primary.main })}
        lineHeight={(theme) => theme.spacing(8.5)}
      >
        Get in touch
      </Typography>
      <Typography
        sx={(theme) => ({ color: theme.palette.primary.main })}
        pb={{ xs: 6, sm: 4 }}
        lineHeight={(theme) => theme.spacing(6)}
      >
        We&apos;re available Mon-Fri, 8AM to 9PM (AEST)
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} minWidth="100%" gap={{ xs: 4, sm: 6 }}>
        {contactLinks.map((link) => (
          <LinkCard key={link.href} href={link.href} maxWidth={{ sm: '300px' }}>
            <Stack direction="row" alignItems="center">
              <IconContainer>
                <link.icon sx={(theme) => ({ color: theme.palette.primary.main })} />
              </IconContainer>
              <Box>
                <Text pb={1}>{link.text}</Text>
                {link.subText && <Text>{link.subText}</Text>}
              </Box>
            </Stack>
          </LinkCard>
        ))}
      </Stack>
    </>
  );
}
